module.exports = __webpack_public_path__ + "public/img/qq.c913a552.svg";